import React from "react";
import TitleSection from "../../../../../../Shared/TitleSection/TitleSection";
import { BiPlusCircle } from "react-icons/bi";
import BrochureCard from "./BrochureCard/BrochureCard";
import AddBrochure from "./AddBrochure/AddBrochure";

const MyBrochure = () => {
  const [addOpen, setAddOpen] = React.useState(false);
  const HandlerAddBrochure = () => {
    setAddOpen(true);
  };
  return (
    <>
      <div className="content">
        <TitleSection text="My Brochure List" />
        <div
          className="row
        mb-o mt-3"
        >
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-12 d-flex justify-content-between ">
                    <div className="col-sm-6 ">
                      <div className="d-flex mb-2 justify-content-between align-items-center column-gap-3">
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search your brochure by Name , Project name ."
                        />
                        <div className="filterbtncontainer d-flex justify-content-between align-items-center column-gap-2">
                          <button className="btn btn-success">Filter</button>
                          <button className="btn btn-light">Cancel</button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 ">
                      <div className="text-end w-auto">
                        <div
                          onClick={HandlerAddBrochure}
                          className="btn  w-auto d-inline-flex justify-content-center column-gap-1 align-content-center btn-outline-success"
                        >
                          <i>
                            <BiPlusCircle size={15} />
                          </i>
                          Add From Library
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <BrochureCard
                    url={
                      "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171645.pdf"
                    }
                    name={"Awadh City"}
                  />
                  <BrochureCard
                    url={
                      "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171737.pdf"
                    }
                    name={"Awadh City Ph-3"}
                  />
                  <BrochureCard
                    url={
                      "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171818.pdf"
                    }
                    name={"Awadh City D block Map"}
                  />
                  <BrochureCard
                    url={
                      "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171943.pdf"
                    }
                    name={"Highway County Map"}
                  />
                  <BrochureCard
                    url={
                      "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025172132.pdf"
                    }
                    name={"Dholera Green City New"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddBrochure addOpen={addOpen} setAddOpen={setAddOpen} />
    </>
  );
};

export default MyBrochure;
